<template>
  <div v-if="isLoaded" class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/albums">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Редактирование альбома</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Имя альбома" name="title"></new-input>
              <div class="images-album">
                <image-album v-for="(image, index) of item.object"
                             :image="image.img"
                             :imgDesc="image.img_desc"
                             :index="index"
                             :key="index"
                />
                <div class="image-album add" @click="addField">
                  <icon-plus/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'
  import ImageAlbum from "@/components/edit-form/ImageAlbum";
  import IconPlus from "../../../icons/IconPlus";

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data: function () {
      return {
        ckeditor: null,
        text: '',
        isLoaded: false
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent',
        'isError',
        'savedFields'
      ]),
      apiUrls() {
        return this.$store.state.apiUrls
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset',
      ]),
      ...mapMutations([
        'setItemField',
        'checkFieldFilling',
        'resetModule'
      ]),
      onSubmit() {
        let object = [];
        for (let i = 0; i < this.item.object.length; i++) {
          object.push({img: this.item[`img_${i}`], img_desc: this.item[`img_desc_${i}`]})
        }
        this.edit({
          title: this.item.title,
          object: JSON.stringify(object)
        })
      },
      addField() {
        this.checkFieldFilling();
        if (!this.isError) {
          this.item.object.push({url: '', img_desc: ''});
          let object = JSON.parse(JSON.stringify(this.item.object));
          this.setItemField({fieldName: 'object', value: object});
        }
      }
    },
    mounted() {
    },
    created() {
      this.resetModule()
      this.init({
        textContent: {
          title: 'Альбомы',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование альбома',
        },
        errors: {
          title: {message: 'Введите название альбома', hasError: false},
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then((data) => {
        if (data.object === null) {
          this.setItemField({fieldName: 'object', value: []});
        }
        if (Object.keys(this.savedFields).length) {
          for (let key in this.savedFields) {
            if (this.savedFields.hasOwnProperty(key)) {
              if (key.includes('img_')) {
                let splitArray = key.split('_')
                let nameKey = key.includes('img_desc') ? 'img_desc' : 'img'
                let indexKey = splitArray[splitArray.length - 1]
                let object = JSON.parse(JSON.stringify(this.item.object));
                object[indexKey][nameKey] = this.savedFields[key]
                console.log(object)
                this.setItemField({fieldName: 'object', value: object})
              }
            }
          }
        }
        this.isLoaded = true
      })
    },
    components: {
      IconPlus,
      ImageAlbum,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload
    }
  }
</script>
<style lang="scss" scoped>
  .images-album {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    .image-album {
      width: calc(50% - 20px);
      margin: 10px;
      padding: 15px;
      border-radius: 4px;
      border: 1px solid #e4e8eb;

      &.add {
        display: flex;
        transition: 0.3s;
        align-items: center;
        svg {
          color: #f8f9fb;
          width: 60px;
          height: 60px;
          stroke: #c6c8ca;
          stroke-width: 3px;
          overflow: visible;
          transition: 0.3s;
          margin: 70px auto;
        }
        &:hover {
          border: 1px solid #089cd3;
          color: #089cd3;
          background: rgba(8, 156, 211, 0.2);
          transition: 0.3s;
          cursor: pointer;
          svg {
            color: white;
            stroke: #089cd3;
            transition: 0.3s;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/albums/pages/Edit.vue